import Api from './Api'

export default {
  async register(parameters) {
    const api = await Api()
    return api.post('register', parameters)
  },
  async login(parameters) {
    const api = await Api()
    return api.post('login', parameters)
  },
  async logout(parameters) {
    const api = await Api()
    return api.post('logout', parameters)
  },
  async forgotPassword(parameters) {
    const api = await Api()
    return api.post('forgot-password', parameters)
  },
  async resetPassword(parameters) {
    const api = await Api()
    return api.post('reset-password', parameters)
  },
  async show(parameters) {
    const api = await Api()
    return api.post('orgs', parameters)
  },
  async whoami(parameters) {
    const api = await Api()
    return api.post('users/me', parameters)
  },
  async userLogout(parameters) {
    const api = await Api()
    return api.post('userLogout', parameters)
  },
}
